export default {
    fetching: false,
    fetchingSingle: false,
    fetchingError: undefined,
    fetchingSingleError: undefined,
    singlePatient: undefined,
    details: {}
}



// WEBPACK FOOTER //
// ./src/redux/reducers/patient/init.js